import React, { useCallback } from 'react'
import { Route, Switch, useHistory } from 'react-router'
import * as firebase from 'firebase/app'
import 'firebase/auth'

import DrawerMenu from '../components/drawerMenu'
import Transactions from './transactions'
import Users from './users'
import TransactionEdit from './transactionEdit'
import User from './user'

function App() {
  const history = useHistory()

  const handleSignoutClick = useCallback(
    async () => {
      await firebase.auth().signOut()

      history.push('/login')
    },
    [history],
  )

  return (
    <div className="w-fullbg-offWhite flex">
      <div className="h-screen bg-darkBlue" style={{ width: 320 }}>
        <DrawerMenu />
      </div>
      <div className="w-full h-screen overflow-auto p-4">
        <div className="flex justify-end">
          <button onClick={handleSignoutClick}>Sign out</button>
        </div>
        <Switch>
          <Route path="/transactions/:transactionId" component={TransactionEdit} />
          <Route path="/transactions" component={Transactions} />
          <Route path="/users/:userId/transactions/:transactionId" component={TransactionEdit} />
          <Route path="/users/:userId" component={User} />
          <Route path="/users" component={Users} />
          <Route path="/" component={Transactions} />
        </Switch>
        {/* <Route path="/campaigns/messages" component={MessageCampaigns} />
				<Route path="/transactions/history" component={TransactionHistory} /> */}
      </div>
    </div>
  )
}

export default App
